/**
 * 适配器模块统一导出
 */

export { autoTriggerAdapter, AutoTriggerAdapter } from "./AutoTriggerAdapter";
